import React, { useId } from 'react';
import { colors } from '../../theme';

/**
 * The product's mark — the same box that `web/public/favicon.svg` and the till's executable icon
 * draw, so the browser tab, the Start Menu shortcut and the page all show one logo.
 *
 * Inline rather than an <img>: it has to sit on a dark hero and a white card at several sizes
 * without a second asset, and it is small enough that a request for it would cost more than it.
 */
export function LogoMark({ size = 40, radius }) {
  // Two marks on one page would otherwise share a gradient id.
  const gradientId = `sf-mark-${useId().replace(/[^\w-]/g, '')}`;
  const rx = radius ?? 14;

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label="StockFlow" style={{ display: 'block', flexShrink: 0 }}>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#6366f1" />
          <stop offset="1" stopColor="#4f46e5" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx={rx} fill={`url(#${gradientId})`} />
      <g fill="none" stroke="#fff" strokeWidth="3.5" strokeLinejoin="round" strokeLinecap="round">
        <path d="M16 22 32 14 48 22 32 30 16 22Z" />
        <path d="M16 22v20l16 8 16-8V22" />
        <path d="M32 30v20" />
      </g>
    </svg>
  );
}

export default function Logo({ size = 38, color = colors.text, subtitle }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
      <LogoMark size={size} radius={size <= 28 ? 16 : 14} />
      <div style={{ lineHeight: 1.15 }}>
        <div style={{ fontSize: size * 0.55, fontWeight: 800, letterSpacing: '-0.03em', color }}>
          StockFlow
        </div>
        {subtitle && (
          <div style={{ fontSize: size * 0.3, fontWeight: 600, color: colors.textMuted, letterSpacing: '0.02em' }}>
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
}
